export default "__VITE_ASSET__B01KNOTa__"